import React, { useEffect, useState } from "react";
import {
  GetDataFromServer,
  GetDataListById,
  GetDataListByIdFromServer,
  GetDataListFromServer,
} from "../../../lib/api";
import { GAME_LIST_PROVIDER, GAME_LOG_API } from "../../../lib/config";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  Button,
  Col,
  DatePicker,
  Row,
  Select,
  Space,
  Table,
  Tabs,
  Typography,
} from "antd";
import { moneyFormat, queryHandler } from "../../../lib/global_functions";
import GameLogExpandable from "./game_logs_expandable";
import moment from "moment-timezone";
import dayjs from "dayjs";

const { Text } = Typography;
const { Option } = Select;
export default function GameLogs({ detail }) {
  const { access_token, ui_size, csrf_token } = useSelector(
    (state) => state.user
  );

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [providerList, setProviderList] = useState([]);

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const [filter, setFilter] = useState({
    win_type: "",
    start_date: "",
    end_date: "",
  });

  async function getProviderList() {
    setLoading(true);
    await GetDataFromServer(GAME_LIST_PROVIDER, access_token)
      .then(({ data: { data: res } }) => {
        setLoading(false);
        setProviderList(res);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  async function getDataList(page_number, per_page, updateFilter) {
    const currentFilter = updateFilter || filter;
    const queryFilter = {
      ...currentFilter,
      end_date: currentFilter.end_date
        ? dayjs(currentFilter.end_date).add(1, "day").format("YYYY-MM-DD")
        : "",
    };

    const QUERY_GAME_LOG = {
      filter: [
        ...(currentFilter.provider
          ? [{ name: "provider", key: "ILike", type: "string" }]
          : []),
        { name: "win_type", key: "ILike", type: "string" },
        { name: "start_date", key: "ILike", type: "string" },
        { name: "end_date", key: "ILike", type: "string" },
      ],
      order: ["created_at"],
    };

    setLoading(true);
    await GetDataListByIdFromServer(
      GAME_LOG_API,
      detail.id,
      queryHandler(queryFilter, QUERY_GAME_LOG, {
        page_number,
        per_page,
      }),
      access_token,
      csrf_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        updateFilter && setFilter(updateFilter);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(res);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getProviderList();
    getDataList(pagin.page_number, pagin.per_page);
  }, []);

  const tabItems = [
    { key: "ALL", label: "All" },
    ...providerList.map((provider) => ({
      key: provider.value,
      label: provider.label,
    })),
  ];

  const handleTabChange = (providerValue) => {
    const updatedFilter = { ...filter };

    if (providerValue === "ALL") {
      const { provider, ...rest } = updatedFilter;
      setFilter(rest);
      getDataList(pagin.page_number, pagin.per_page, rest);
    } else {
      updatedFilter.provider = providerValue;
      setFilter(updatedFilter);
      getDataList(pagin.page_number, pagin.per_page, updatedFilter);
    }
  };

  const columns = [
    {
      title: "User Code",
      dataIndex: "user_code",
      key: "user_code",
    },
    {
      title: "Provider",
      dataIndex: "provider",
      key: "provider",
    },
    {
      title: "Game Name",
      dataIndex: "game_name",
      key: "game_name",
    },
    {
      title: "Before betting",
      dataIndex: "before_bet",
      render: (record) => {
        return (
          <Text style={{ color: "cyan" }}>{moneyFormat(record || 0)}</Text>
        );
      },
    },
    {
      title: "Bet Amount",
      dataIndex: "bet",
      render: (record) => moneyFormat(record || 0),
    },
    {
      title: "After Betting",
      dataIndex: "after_bet",
      render: (record) => {
        return (
          <Text style={{ color: "mediumspringgreen" }}>
            {moneyFormat(record || 0)}
          </Text>
        );
      },
    },
    {
      title: "Before Result",
      dataIndex: "before_result",
      render: (record) => {
        return (
          <Text style={{ color: "cyan" }}>{moneyFormat(record || 0)}</Text>
        );
      },
    },
    {
      title: "Result",
      dataIndex: "result",
      render: (result, record) =>
        result !== "0" ? (
          record.result_addition ? (
            <Text>+{moneyFormat(result)}</Text>
          ) : (
            <Text>-{moneyFormat(result)}</Text>
          )
        ) : (
          <Text>{moneyFormat(result)}</Text>
        ),
    },
    {
      title: "After Result",
      dataIndex: "after_result",
      render: (record) => {
        return (
          <Text style={{ color: "mediumspringgreen" }}>
            {moneyFormat(record || 0)}
          </Text>
        );
      },
    },
    {
      title: "Win/Loss",
      render: (_, record) =>
        record.result === "0" ? (
          <Text style={{ color: "red" }}>Lose</Text>
        ) : record.result !== "0" ? (
          record.result_addition ? (
            <Text style={{ color: "lime" }}>Win</Text>
          ) : (
            <Text style={{ color: "red" }}>Lose</Text>
          )
        ) : null,
    },
    {
      title: "Date",
      dataIndex: "updated_at",
      render: (updated_at) => {
        return moment
          .utc(updated_at)
          .tz("Asia/Yangon")
          .format("DD-MM-YYYY, HH:mm:ss");
      },
    },
  ];

  function clearFilter() {
    getDataList(pagin.page_number, pagin.per_page, {
      ...filter,
      win_type: "",
      start_date: "",
      end_date: "",
    });
  }

  return (
    <Col span={24}>
      <Tabs
        activeKey={filter.provider || "ALL"}
        onChange={handleTabChange}
        items={tabItems}
        size={ui_size}
      />

      <Col span={24}>
        <Row align="middle">
          <Col>Type : &nbsp;</Col>
          <Col>
            <Select
              size={ui_size}
              style={{ width: "150px" }}
              placeholder="Select Type"
              value={filter.win_type || undefined}
              onChange={(value) => setFilter({ ...filter, win_type: value })}
              allowClear={false}
            >
              <Option value="WIN">Win</Option>
              <Option value="LOSE">Lose</Option>
            </Select>
          </Col>

          <Col style={{ marginLeft: "20px" }}>Date : &nbsp;</Col>
          <Col>
            <DatePicker.RangePicker
              size={ui_size}
              style={{ width: "300px" }}
              format={"YYYY-MM-DD"}
              value={[
                filter.start_date
                  ? dayjs(filter.start_date, "YYYY-MM-DD")
                  : null,
                filter.end_date ? dayjs(filter.end_date, "YYYY-MM-DD") : null,
              ]}
              onChange={(dates) => {
                setFilter({
                  ...filter,
                  start_date: dates?.[0]?.format("YYYY-MM-DD") || "",
                  end_date: dates?.[1]?.format("YYYY-MM-DD") || "",
                });
              }}
            />
          </Col>

          <Col style={{ marginLeft: "20px" }}>
            <Space>
              <Button
                size={ui_size}
                type="primary"
                onClick={() => {
                  getDataList(1, pagin.per_page);
                }}
              >
                Search
              </Button>
              <Button
                size={ui_size}
                type="primary"
                onClick={() => clearFilter()}
              >
                Clear
              </Button>
            </Space>
          </Col>
        </Row>
      </Col>

      <Table
        size={ui_size}
        loading={loading}
        columns={columns}
        dataSource={list}
        rowKey={(e) => e.id}
        style={{ marginTop: "20px" }}
        pagination={{
          total: pagin.total,
          current: pagin.page_number,
          pageSize: pagin.per_page,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50],
          onChange: (pageNumber, perPage) => {
            getDataList(pageNumber, perPage);
          },
          onShowSizeChange: (current, size) => {
            getDataList(1, size);
          },
        }}
        expandable={{
          expandedRowRender: (record) => <GameLogExpandable record={record} />,
        }}
      />
    </Col>
  );
}
